import React from 'react';
import { Link } from 'react-router-dom';
import PublicPage from '../components/public/PublicPage';
import usePageTitle from '../hooks/usePageTitle';
import { CHECKS, FAQS } from '../content/siteContent';
import './PublicPages.css';

const FaqPage = () => {
  usePageTitle('FAQ', 'Answers to common questions about TenantVerify SA, and the checks a landlord or agent can request.');

  return (
    <PublicPage>
      <section className="pub-hero">
        <div className="public-container pub-narrow">
          <p className="pub-eyebrow">FAQ</p>
          <h1>Questions and answers</h1>

          <div className="landing-faq">
            {FAQS.map(({ q, a }) => (
              <details key={q}>
                <summary>{q}</summary>
                <p>{a}</p>
              </details>
            ))}
          </div>

          <h2 id="checks">The checks a landlord or agent can request</h2>
          <p>Checks depend on the property requirements, applicant consent and provider availability.</p>
          <ul>
            {CHECKS.map(({ title, text }) => <li key={title}><strong>{title}.</strong> {text}</li>)}
          </ul>

          <p>Something else? <Link to="/contact">Contact us</Link>.</p>
        </div>
      </section>
    </PublicPage>
  );
};

export default FaqPage;
